module.exports = __webpack_public_path__ + "static/media/makeover4.8ebef878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/makeover4.jpg
// module id = 330
// module chunks = 0